import { FunctionComponent } from 'react';
import { FindingCitation } from 'types/findings';
import { citationAccessibleName, citationLabel } from 'utils/citationLabel';
import './CitationChip.css';

export interface CitationChipProps {
  citation: FindingCitation;
  /**
   * Optional callback invoked when the chip is activated. Native button
   * semantics provide mouse, Enter, and Space activation.
   */
  onActivate?: (citation: FindingCitation, trigger: HTMLButtonElement) => void;
}

/**
 * Clickable pill/chip rendering a single legislation citation. Citation
 * details and any verified official source link are shown in-app by the
 * owning FindingCard rather than navigating directly from the badge.
 */
export const CitationChip: FunctionComponent<CitationChipProps> = ({ citation, onActivate }) => {
  const label = citationLabel(citation.urn);
  const accessibleName = citationAccessibleName(citation.urn);

  return (
    <button
      type="button"
      className="citation-chip"
      data-testid="citation-chip"
      data-urn={citation.urn}
      aria-label={accessibleName}
      title={citation.excerpt || citation.snippet || accessibleName}
      onClick={(event) => onActivate?.(citation, event.currentTarget)}
    >
      <span className="citation-chip__label">{label}</span>
    </button>
  );
};
